export default __webpack_public_path__ + "static/gulabjamun-4e7ad20209fbbd2fe5759387aed20356.png";